import React, { useCallback, useMemo } from 'react';

import MoreButtonCDS from 'app/shared/componentsRestyled/coreDesignSystem/Buttons/MoreButtonCDS';
import MenuPopoverCDS from 'app/shared/componentsRestyled/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import usePopover from 'hooks/usePopover';

const DeleteActionButton = ({ onDelete, id, isDisabled = false }) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const onDeleteClick = useCallback(() => {
    onDelete({ id });
  }, [onDelete, id]);

  const items = useMemo(
    () => [
      {
        text: 'Delete',
        onClick: onDeleteClick,
      },
    ],
    [onDeleteClick],
  );

  return (
    <>
      <MoreButtonCDS disabled={isDisabled} isSelected={!!anchorEl} onClick={onSetAnchorElement} />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

DeleteActionButton.propTypes = {
  id: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default DeleteActionButton;
